import React from "react";
import './Title.css';

export default function Title({ props })
{
    return (
        <h1 className={ props.type }>{ props.title }</h1>
    )
}